import { QNImageUtil } from './qiniuImageUtil'
import { UrlUtil } from './urlUtil'
import { StringUtil } from './stringUtil'
import wx from 'weixin-js-sdk'

/**
 * 判断是否为微信小程序
 * @export
 * @returns
 */
function isWeChatMiniApp() {
    const ua = window.navigator.userAgent.toLowerCase()
    return new Promise((resolve) => {
        if (ua.indexOf('micromessenger') === -1) { // 不在微信或者小程序中
            resolve(false)
        } else {
            // eslint-disable-next-line
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    resolve(true)
                } else { // 在微信中
                    resolve(false)
                }
            })
        }
    })
}

const AppType = {
  isInWeChat: function() { // 判断是否是在微信内打开
    return /MicroMessenger/i.test(window.navigator.userAgent)
  },
  isInQQ: function() { // 判断是否是在微信内打开
    return /QQ/i.test(window.navigator.userAgent) && /mobile/i.test(window.navigator.userAgent)
  },
  isInApp: function() { // 包含bmb and bmLive
    return /Banma/i.test(window.navigator.userAgent)
  },
  isInBmApp: function() {
    return /Banma/i.test(window.navigator.userAgent) && !(/BanmaLive/i.test(window.navigator.userAgent))
  },
  isInLiveApp: function() {
    return /BanmaLive/i.test(window.navigator.userAgent)
  },
  isInAndroid: function() { // android终端
    var u = navigator.userAgent
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  },
  isInIOS: function() { // ios终端
    var u = navigator.userAgent
    //return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    return /iPhone|iPad|iPod/i.test(u)
  },
  isInMiniProgram: function () { // 判断是否是在小程序内打开
    return /miniprogram/i.test(window.navigator.userAgent);
  }
}

export { QNImageUtil, UrlUtil, StringUtil, isWeChatMiniApp, AppType }